import { Box, SelectProps } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React, { useMemo } from "react"
import { useCurrentAvailableProductsForPage } from "~/hooks/useCurrentAvailableProductsForPage"
import { useLineItem } from "~/hooks/useLineItem"
import LineItemPreviewProductSelector from "./LineItemPreviewProductSelector"

export interface Props extends SelectProps {
  currentProductId: EntityId
  onProductChange: (id: EntityId) => void
  onEdit?: () => void
  lineItemId: EntityId
}

const LineItemPreviewProductSelectorWrapper: React.FC<Props> = ({
  currentProductId,
  onProductChange,
  onEdit,
  lineItemId,
}) => {
  const { product } = useLineItem(lineItemId)
  const { products } = useCurrentAvailableProductsForPage()

  const isAPhotoBook = product.categoryName === "photo-book"

  const productList = useMemo(() => {
    const list = isAPhotoBook
      ? products.filter(product => product.categoryName === "photo-book")
      : products.filter(product => product.categoryName !== "photo-book")

    return list
  }, [isAPhotoBook, products])

  if (isAPhotoBook) {
    return (
      <Box
        className="disabled-product-selector"
        onClick={onEdit}
        w="full"
        h="full"
      >
        <LineItemPreviewProductSelector
          currentProductId={currentProductId}
          onProductChange={onProductChange}
          isDisabled={true}
          products={productList}
        />
      </Box>
    )
  }

  return (
    <LineItemPreviewProductSelector
      currentProductId={currentProductId}
      onProductChange={onProductChange}
      isDisabled={false}
      products={productList}
    />
  )
}

export default LineItemPreviewProductSelectorWrapper
